import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLectureNoApi } from "../../apis/lecture/lecture";

export const getLectureNo = createAsyncThunk(
  "lecture/get-all",
  async ({ subjectId, classTypeId, classLevelId, yearId, isSoloClass }) => {
    const response = await getLectureNoApi({
      subjectId,
      classTypeId,
      classLevelId,
      yearId,
      isSoloClass,
    });
    console.log("Response from the api", response.data.data);
    return response.data.data;
  }
);

const lectureSlice = createSlice({
  name: "lecture",
  initialState: {
    lecture: "",
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLectureNo.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getLectureNo.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.lecture = action.payload;
      })
      .addCase(getLectureNo.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Something went wrong.";
      });
  },
});

export default lectureSlice.reducer;
